import React, { useContext } from 'react'

import { DataContext } from '../../Context/DataContext'

import { capitalizeFirstLetter } from '../../utils'

const Social = ({ whitemode, dark }) => {
    const { socials } = useContext(DataContext)
    const socialLinks = Object.fromEntries(
        Object.entries(socials).filter(([key]) => key !== 'email')
    )
    return (
        <ul className={`mga-social${whitemode ? ' mga-social--light' : (dark ? ' mga-social--dark' : '')}`}>
            {
                Object.entries(socialLinks).map(([key, value]) => (
                    <li
                        key={key}
                        className={`mga-social__item mga-social__item--${key}`}
                    >
                        <a href={value} target="_blank" rel="noopener noreferrer">{capitalizeFirstLetter(key)}</a>
                    </li>
                ))
            }
        </ul>
    )
}

Social.defaultProps = {
    whitemode: false,
    dark: false,
}

export default React.memo(Social)